/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Trending_DescriptionInputs */

const en_header_trending_description = /** @type {(inputs: Header_Trending_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a scene. Make it your own.`)
};

/**
* | output |
* | --- |
* | "Pick a scene. Make it your own." |
*
* @param {Header_Trending_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const header_trending_description = /** @type {((inputs?: Header_Trending_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Trending_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_trending_description(inputs)
});
export { header_trending_description as "header.trending.description" }